/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Area } from '../_models/area.model';

@Injectable()
export class AreaService {
  constructor(private http: HttpClient) {}

  getAllAreas(): Observable<Area[]> {
    return this.http.get<Area[]>('api/shipments/areas/');
  }

  findAreas(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<QueryResultsModel>(
      'api/shipments/areas/find/',
      queryParams,
      { headers: httpHeaders }
    );
  }

  deleteArea(area: Area) {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    const url = `api/shipments/areas/${area.id}/`;
    return this.http.delete(url, { headers: httpHeaders });
  }

  createArea(area: Area): Observable<Area> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<Area>('api/shipments/areas/', area, {
      headers: httpHeaders,
    });
  }

  populateForCourier(data: any): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<Area>(
      'api/shipments/areas/populate_for_courier/',
      data,
      { headers: httpHeaders }
    );
  }

  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }
}
